import React from "react"
import "./Index.scss"
import navData from "app/api/navData.js"
import { Link, withRouter } from "react-router-dom"
import { getCurrentApp } from "app/api/localTools"

const SideBar = props => {
  const { location } = props
  let navs = navData[getCurrentApp() || 'pgs']
  navs.forEach(item => {
    if (location.pathname.includes(`/${item.href}`)) {
      item.className ="active"
    }else{
      item.className = ""
    }
  })

  return (
    <sidebar className="page-sidebar">
      <ul className="page-sidebar-nav">
        {navs.map((item, index) => (
          <li key={index} className={`${item.className || ""}`} >
            <Link to={`/public/main/${getCurrentApp()}/${item.href}`}>
              <span className={`sidebar-icon sidebar-icon-${item.icon}`} />
              <span className="sidebar-title">
                {item.text}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </sidebar>
  )
}

export default withRouter(SideBar)



// WEBPACK FOOTER //
// ./src/app/components/common/Sidebar/index.js